<template>
  <div >
    <div class="portlet-body">
      <portlet :clase="'container col-md-12 blockui_sample_3_2_element'">
        <template slot="tools">
          <div class="top-menu">
            <div class="dropdown dropdown-quick-sidebar-toggler">
              <button class="btn btn-circle  green" tarjet="_blank" data-toggle='modal' title='Descargar Reporte' v-on:click="rdownload()">Descarga Rápida <i class="fa fa-download"></i></button>
              <a href="javascript:;" class="btn btn-circle blue dropdown-toggle">Filtros <i class="fa fa-sliders"></i></a>  
            </div>
          </div>
        </template>
        <template slot="caption">
          <div class="row"> 
            <div class='col-md-8'>          
              <span class="caption-subject bold uppercase"> <i class="fa fa-cogs"></i> Reporte facilidades administrativas, estímulos fiscales y compensaciones</span>          
            </div> 
          </div>  
        </template>      
        <template slot="body">         
          <div class="row">
            <tableSample :lengthMenu="lengthMenu" :columns="table_columns" :data_="data_" :id="'sample_2'" v-if="renderTable"/>         
          </div>
        </template>
      </portlet>
    </div>
    <Sidebar :title="'Filtros'">
      <template slot="body">
        <div class="col-md-12 blockui_sample_3_2_element">
          <div class="portlet light bordered">
            <div class="panel-body">        
              <div class="row">
                <div class='col-md-6 col-ms-6'>
                  <div class='form-group'>
                    <label >Reporte*</label>
                    <select2 class="form-control" :options="options" v-model="tipo_reporte">
                        <option v-for="b in data_reporte" :value="b.id"> {{ b.name}}</option>
                    </select2>
                  </div>
                </div>
                <div class='col-md-6 col-ms-6'>
                  <div class='form-group'>
                    <label >RFC</label>
                   <input type="text" placeholder="RFC" class="form-control" v-model="rfc_busqueda">
                  </div>
                </div>
                <div class='col-md-12 col-ms-12'>
                  <div class='form-group text-right'>
                   <button type="button" class="btn blue" v-on:click="tipoFiltro()"> Buscar <i class="fa fa-search"></i></button> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                   <button type="button" class="btn green" v-on:click="reporteDownload()"> Exportar <i class="fa fa-file-excel-o"></i></button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </Sidebar>
    <form id="form_facilidades" :action="link_download_facilidades" method="post">
      <input type="hidden" name="_token" :value="csrfToken">
      <input type="hidden" :value="rfc_busqueda"  id="ids_facilidades" name="rfc">          
    </form>  
    <form id="form_prestadora" :action="link_download_prestadora" method="post">
      <input type="hidden" name="_token" :value="csrfToken">
      <input type="hidden" :value="rfc_busqueda" id="ids_prestadora" name="rfc">
    </form>
    <form id="form_facilidad_isn" :action="link_download_detalle_estimulos" method="post">
      <input type="hidden" name="_token" :value="csrfToken">
      <input type="hidden" :value="rfc_busqueda" id="ids_facilidad_isn" name="rfc">
    </form>
  </div>
   
</template>  
<script>
  import axios from 'axios'
  import portlet from './General/Portlet.vue'
  //import modal from './General/Modal.vue'
  import modal from './Individual/RecModal.vue'
  import modalconfirmation from './General/ModalConfirmation.vue'
  import tableSample from './Individual/TableFacilidades.vue'
  import VCalendar from 'v-calendar'
  import select2 from './General/Select.vue'
  import Sidebar from './General/Sidebar.vue'
  import * as XLSX from 'xlsx'
  import { saveAs } from 'file-saver'

  export default {
    name: 'ReporteEstadistica',
    components: {axios,portlet,modal,modalconfirmation,tableSample,VCalendar,Sidebar,select2},
    data(){
      return{
        renderTable:false,
        options:[],
        lengthMenu:[],
        data_id:[],
        data_:[],
        csrfToken: document.head.querySelector('meta[name="csrf-token"]').content,
        link_download_facilidades:`${process.env.APP_URL}/reporte-facilidad`,
        link_download_prestadora:`${process.env.APP_URL}/reporte-prestadoras`,
        link_download_detalle_estimulos:`${process.env.APP_URL}/export-facilidad-isn`,
        table_columns:[],
        table_ctrl:[
          {"data":"rfc", "title":"RFC","width":"10%"},
          {"data":"cuenta", "title":"Cuenta","width":"10%"},
          {"data":"nombre_razonS", "title":"Nombre","width":"10%"},
          {"data":"impuesto", "title":"Impuesto","width":"10%"},
          {"data":"desc_tipo_facilidad", "title":"Tipo de facilidad","width":"10%"},
          {"data":"Folio", "title":"Folio","width":"10%"},
          {"data":"oficio", "title":"Oficio de autorización","width":"10%"},
          {"data":"facilidades","title":"Estatus","width":"10%"}
        ],
        tipo_reporte:"2",
        rfc_busqueda:"",
        data_reporte:[
          {id:"2",name:"Reporte de Facilidades, estímulos y compensaciones"},
          {id:"1",name:"Detalle de Prestadoras relacionadas"},
          {id:"3",name:"Detalle de Estímulos ISN"},
          {id:"general_saldos",name:"Reporte del Control General de Saldos"},
          {id:"general_saldos_detalle",name:"Detalle del Control General de Saldos"},
          {id:"detalle_compensaciones",name:"Reporte Detalle de Compensaciones"}
        ],
        table_facilidad:[
          {"data":"rfc" , "title":"RFC"},
          {"data":"cuenta", "title":"Cuenta","width":"10%"},
          {"data":"nombre_completo", "title":"Nombre","width":"10%"},
          {"data":"impuesto", "title":"Impuesto"},
          {"data":"descripcion", "title":"Tipo de facilidad"},
          {"data":"folio", "title":"Folio"},
          {"data":"fundamento_legal", "title":"Oficio de autorización","width":"10%"},
          {"data":"estatus","title":"Estatus","width":"10%"}
        ],
        table_detalle_compensaciones:[
          {"data":"rfc", "title":"RFC"},
          {"data":"folio", "title":"Folio"},
          {"data":"oficio_autorizacion", "title":"No. Oficio Autorización"},
          {"data":"tipo", "title":"Tipo"},
          {"data":"subtipo", "title":"Subtipo"},
          {"data":"folio_pago", "title":"Folio de Pago"},
          {"data":"impuesto", "title":"Impuesto"},
          {"data":"monto_a_compensar", "title":"Monto a Compensar"},
          {"data":"pago_duplicado", "title":"Pago Duplicado"},
          {"data":"pago_en_exceso", "title":"Pago en Exceso"},
          {"data":"fecha_alta", "title":"Fecha de Alta"},
          {"data":"usuario_alta", "title":"Usuario de Alta"},
          {"data":"estatus_detalle", "title":"Estatus del Detalle"},
          {"data":"fecha_eliminacion", "title":"Fecha de Eliminación"},
          {"data":"usuario_elimina", "title":"Usuario que Elimina"},
          {"data":"fecha_captura_eliminacion", "title":"Fecha de Captura de la Eliminación"},
          {"data":"fecha_consulta", "title":"Fecha de Consulta"}
        ]
      }
    },
    methods:{
        
        tipoFiltro(){
          if(this.tipo_reporte=="0" ){
            this.notifications('400',"Selecciona el reporte");
          }else if(this.tipo_reporte=="general_saldos" || this.tipo_reporte=="general_saldos_detalle" ){
            this.filterResponseDetalle();
          }else if(this.tipo_reporte=="detalle_compensaciones"){
            this.filterDetalleCompensaciones();
          }else{
            this.filterFacilidades();
          }
        },
        filterDetalleCompensaciones(){
          this.table_columns=this.table_detalle_compensaciones;
          this.loagingC(true);
          this.data_=[];
          this.renderTable=false;
          axios.post(`${process.env.APP_URL}/facilidades-detalle-compensaciones`,{
            rfc:this.rfc_busqueda
          })
          .then((response)=>{
              this.data_=response.data.Response;
              this.renderTable=true;
              this.loagingC(false);
              if(response.data.Code!=="200"){
                this.notifications('400', response.data.Message || "Error al consultar el reporte");
              }
          }).catch(error=>{
              this.notifications('400',"Error al consultar el reporte");
              this.loagingC(false);
              console.log(error)
          })
        },
        filterResponseDetalle(){
          let url=`${process.env.APP_URL}/facilidades-control-saldos`;
          if(this.tipo_reporte=="general_saldos_detalle"){
            url=`${process.env.APP_URL}/facilidades-detalle-saldos`;
          }
          this.table_columns=this.table_ctrl;
          this.loagingC(true);
          this.data_=[];
          this.renderTable=false;
          axios.post(url,{
            rfc:this.rfc_busqueda
          })
          .then((response)=>{         
              //console.log(response.data); 
              this.data_=response.data.response;
              this.renderTable=true;
              this.loagingC(false);
          }).catch(error=>{
              this.notifications('400',"Registros no encontrados");
              this.loagingC(false);
              console.log(error)
          })
        },
        filterFacilidades(){
            this.loagingC(true);
            this.table_columns=this.table_facilidad;
            this.data_=[];
            this.renderTable=false;
            axios.post(`${process.env.APP_URL}/find-facilidades`,{
              rfc:this.rfc_busqueda, 
              tipo:this.tipo_reporte
            })
            .then((response)=>{         
                //console.log(response.data); 
                this.data_=response.data;
                this.renderTable=true;
                this.loagingC(false);
            }).catch(error=>{
                this.notifications('400',"Registros no encontrados");
                this.loagingC(false);
                console.log(error)
            })
        },
        reporteDownload(){
          if(this.tipo_reporte=="0" ){
            this.notifications('400',"Selecciona el reporte");
          }else if(this.tipo_reporte=="general_saldos_detalle"){
            window.open(`${process.env.APP_URL}/facilidades-download-detalle-saldos/` + this.rfc_busqueda, '_blank');
          }else if(this.tipo_reporte=="general_saldos"){
            window.open(`${process.env.APP_URL}/facilidades-download-saldos/` + this.rfc_busqueda, '_blank');
          }else if(this.tipo_reporte=="detalle_compensaciones"){
            window.open(`${process.env.APP_URL}/facilidades-download-detalle-compensaciones/` + this.rfc_busqueda, '_blank');
          }else if(this.tipo_reporte=="1"){
            event.preventDefault();  
            $("#form_prestadora").submit();
          }else if(this.tipo_reporte=="2"){
            event.preventDefault();
            $("#form_facilidades").submit();
          }else if(this.tipo_reporte=="3"){
            event.preventDefault(); 
            $("#form_facilidad_isn").submit();  
          }
        },
        rdownload() {
          if(this.data_.length==0){
            this.notifications('400',"Sin registros");
            return;
          }

          let nm=this.data_reporte.filter((e) => e["id"] === this.tipo_reporte).map((e) => { return e});
          let nombre='Reporte - ' + nm[0].name;

          // Encabezados y orden de columnas se derivan de table_columns (el
          // mismo set que arma cada filterXxx() para el tipo_reporte activo),
          // en vez de un arreglo fijo: así cada tipo de reporte exporta sus
          // propias columnas en el orden correcto, y los campos que el backend
          // regresa de mas (ids internos, etc.) que no estan en table_columns
          // quedan fuera del Excel.
          const columnKeys = this.table_columns.map(c => c.data);
          const headers = this.table_columns.map(c => c.title);
          const data = this.data_.map(row => {
            let ordered = {};
            columnKeys.forEach(key => { ordered[key] = row[key]; });
            return ordered;
          });

          const worksheet = XLSX.utils.json_to_sheet(data, { header: columnKeys });
          const workbook = XLSX.utils.book_new();
          XLSX.utils.sheet_add_aoa(worksheet, [headers], { origin: "A1" });
          XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

          // Generar archivo XLSX
          const xlsxData = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

          // Descargar archivo
          const blob = new Blob([xlsxData], { type: 'application/octet-stream' });
          saveAs(blob, nombre +'.xlsx');
        },
        loagingC(value, index, values) {
            return Vue.filter('loadingCharge')(value);
        },
        notifications(Code,Message){
            if(Code=="200"){
                Command: toastr.success(Message, "Notifications");
            }else{
                Command: toastr.warning(Message, "Notifications");
            }
        }
    },
    mounted() {
      this.table_columns=this.table_ctrl;
      this.renderTable=true;
      this.tipoFiltro();
    },
    computed:{
     }
  }
</script>